import React, { useState, useEffect, useRef } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import ModelPopup from "../../helpers/ModelPopup";
import GetAllClients from "../../helpers/GetAllClients";

// Wrapper to display the API Key form in a modal
const AddApiKeyModal = props => (
  <ModelPopup
    show={props.show}
    onHide={props.onHide}
    modelheading={""}
    showheader={"false"}
    backdrop="static"
    keyboard={false}
    className="smallPopup issueCardSmall"
    dialogClassName="modal-dialog modal-dialog-centered mwidth-76"
    modelbody={
      <ApiKeyForm
        show={props.show}
        onHide={props.onHide}
        onSave={props.onSave}
        initialValues={props.initialValues}
        action={props?.action}

      />
    }
  />
);

const ApiKeyForm = ({ onSave, onHide, initialValues = {},action }) => {
  const form = useRef();
  const checkBtn = useRef();

  // Local state for form fields
  const [clientId, setClientId] = useState(initialValues.clientId || "");
  const [apiKey, setApiKey] = useState("");
  const [isIPActive, setIsIPActive] = useState(initialValues.isIPActive || false);
  const [ipAddress, setIpAddress] = useState(initialValues.ipAddress || "");
  const [isAutoRenew, setIsAutoRenew] = useState(initialValues.isAutoRenew || false);
  const [isDelete, setIsDelete] = useState(initialValues.isDelete || false);

  useEffect(() => {
    if (initialValues) {
      setClientId(initialValues.clientId);
      setApiKey(initialValues.apiKey);
      setIsIPActive(initialValues.isIPActive);
      setIpAddress(initialValues.ipAddress);
      setIsAutoRenew(initialValues.isAutoRenew);
      setIsDelete(initialValues.isDelete);
    }
  }, [initialValues]);

  const handleSubmit = e => {
    e.preventDefault();
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
        // Build payload, default apiKey to empty string if undefined
        const payload = {
          clientId: Number(clientId),
          apiKey: apiKey ?? "",
          isIPActive,
          ipAddress,
          isAutoRenew,
          isDelete,
        };
        onSave(payload);
      }
  };

  return (
    <div className="">
      <div className="row">
        <Form onSubmit={handleSubmit} ref={form}>

          {/* Client selector (unchanged) */}
          <div className="col-md-6" id="client_id">
            <div className="form-group">
              <label>Select Client*</label>
              <div className="form-controls">
                {
                    initialValues?.clientId !=undefined?(<p>{initialValues?.clientName}</p>):(<GetAllClients
                        clientnamechangehandler={e => {
                          const val = e.target.selectedOptions[0]?.value;
                          if (val !== undefined && val !== "") {
                            setClientId(parseInt(val, 10));
                          }
                        }}
                        searchgriddata="Y"
                      />)
                }
              
              </div>
            </div>
          </div>

        

          {/* Enable IP restriction */}
          <div className="col-md-6" id="is_ip_active">
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  checked={isIPActive}
                  onChange={e => {
                    const checked = e.target.checked;
                    setIsIPActive(checked);
                    if (!checked) {
                      setIpAddress("");
                    }
                  }}
                />{' '}
                Restrict by IP
              </label>
            </div>
          </div>

          {/* Conditionally rendered fields when IP restriction is active */}
          {isIPActive && (
            <>
              <div className="col-md-6" id="ip_address">
                <div className="form-group">
                  <label>Allowed IP Address</label>
                  <div className="form-controls">
                    <Input
                      type="text"
                      className="form-control no-icon"
                      value={ipAddress}
                      onChange={e => setIpAddress(isIPActive?e.target.value:"")}
                    />
                  </div>
                </div>
              </div>


            </>
          )}
                        <div className="col-md-6" id="is_auto_renew">
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={isAutoRenew}
                      onChange={e => setIsAutoRenew(e.target.checked)}
                    />{' '}
                    Auto Renew Key
                  </label>
                </div>
              </div>

              <div className="col-md-6" id="is_delete">
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={isDelete}
                      onChange={e => setIsDelete(e.target.checked)}
                    />{' '}
                    Mark for Deletion
                  </label>
                </div>
              </div>

          {/* Action buttons */}
          <div className="col-md-12">
            <div className="form-group submit-field d-flex justify-content-center mt-40 mb-0">
              <a className="btn btn-outline mr-19" onClick={onHide}>
                Cancel
              </a>
              {
                action=="update" ?(<>
                <a className="btn btn-large" onClick={handleSubmit}>
                  Update API Key
                </a>
               
                </>
                  
               
                ):( <a className="btn btn-large" onClick={handleSubmit}>
                  Save API Key
                </a>)
              }
            </div>
            {
              action=="update" && (
                <span className="fs-12 clr-submarine mt-4 d-block text-center">
                *Please note that this will update the API Key as well.
                </span>
              )
            }
          </div>

          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>
      </div>
    </div>
  );
};

export default AddApiKeyModal;
